import { store } from 'quasar/wrappers'
import Vuex from 'vuex'

import user from './user'
import local from './local'
import lesson from './lesson'
import message from './message'
import schedule from './schedule'
import assessment from './assessment'
import session from './session'
import event from './event'
import eLibrary from './eLibrary'
import section from './section'

import { UserStateInterface } from './user/state'
import { LocalStateInterface } from './local/state'
import { LessonStateInterface } from 'src/store/lesson/state'
import { MessageStateInterface } from 'src/store/message/state'
import { ScheduleStateInterface } from 'src/store/schedule/state'
import { SessionStoreInterface } from 'src/store/session/state'
import { EventStateInterface } from 'src/store/event/state'
import { AssignmentStateInterface } from 'src/store/assessment/state'
import { ELibraryStateInterface } from 'src/store/eLibrary/state'
import { SectionStateInterface } from 'src/store/section/state'

/*
 * If not building with SSR mode, you can
 * directly export the Store instantiation
 */

export interface StoreInterface {
  // Define your own store structure, using submodules if needed
  // example: ExampleStateInterface;
  // Declared as unknown to avoid linting issue. Best to strongly type as per the line above.
  user: UserStateInterface;
  local: LocalStateInterface;
  lesson: LessonStateInterface;
  message: MessageStateInterface;
  schedule: ScheduleStateInterface;
  assignment: AssignmentStateInterface;
  session: SessionStoreInterface;
  event: EventStateInterface;
  eLibrary: ELibraryStateInterface;
  section: SectionStateInterface;
}

export default store(function ({ Vue }: any) {
  Vue.use(Vuex)

  return new Vuex.Store<StoreInterface>({
    modules: {
      user,
      local,
      lesson,
      message,
      schedule,
      session,
      event,
      assessment,
      eLibrary,
      section
    },

    // enable strict mode (adds overhead!)
    // for dev mode only
    strict: !!process.env.DEV
  })
})
